import createReducer from '../../../../common/utils/createReducer';
import * as actionTypes from '../../actionTypes';
import { getInterfaceLanguage } from '../../utils/getInterfaceLanguage';
import { getItemFromPersistentStore, setItemInPersistentStore } from '../../utils/Persist';
import { DIRECTION_RTL, DIRECTION_LTR } from '../../constants';
import getQueryParamFromURL from '../../../../common/utils/getQueryParamFromLink';
import isEmpty from 'lodash/isEmpty';


const getPreferredLang = () => {
  const preferredLocale = getQueryParamFromURL().locale;
  if (!isEmpty(preferredLocale)) {
    setItemInPersistentStore('language', preferredLocale);
    return preferredLocale
  }
  const language = getInterfaceLanguage();
  return language;
}

const initialState = {
  language: getPreferredLang(),
  user_details: getItemFromPersistentStore('user_details', {}),
  startChatWithExternalIntent: false,
};

const reducerMap = {
  [actionTypes.SET_LOCALE_FETCHING_STATUS]: (state, action) => {
    const { messages, locale, allMessageFetched } = action.payload;
    const stateUpdates = { ...state, allMessageFetched };
    if (messages) {
      stateUpdates.messages = messages;
    }
    if (locale) {
      stateUpdates.language = locale;
      stateUpdates.direction = locale === 'ar' ? DIRECTION_RTL : DIRECTION_LTR;
    }
    return stateUpdates;
  },
  [actionTypes.SIGNIN_USER_BY_PHONE]: (state, action) => ({
    ...state,
    isloading: false,
    user_details: action.payload.data
  }),
  [actionTypes.SAVE_USER_DETAILS_ON_AUTO_LOGIN]: (state, action) => ({
    ...state,
    user_details: action.payload
  }),
  [actionTypes.SIGNOUT_USER_ON_AUTHENTICATION_FAIL]: (state, action) => {
    const language = state.language;
    return { ...initialState, user_details: {}, language };
  },
  [actionTypes.CHANGE_SELECTED_LANGUAGE]: (state, action) => {
    const { language } = action.payload;
    console.log('Check Selcted, Language', language);
    return {
      ...state,
      language
    }
  },
  [actionTypes.UPDATE_START_OYOCHAT_VIA_EXTERNAL_INTENT]: (state, action) => {
    return {
      ...state,
      startChatWithExternalIntent: !state.startChatWithExternalIntent
    }
  }
};

const DashboardReducer = createReducer(initialState, reducerMap);

export default DashboardReducer;
